(function () {

  //Centers the active link in the horizontally scrollable nav (no library dependency)
  const centerActiveLink = () => {
    const slider = document.querySelector('[data-collection-mobile-navigation-slick]');
    if (!slider) return;

    const active = slider.querySelector('a.active');
    if (!active) return;

    active.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
  };

  const initButtons = () => {
    const menu = document.querySelector('[data-collection-mobile-navigation-menu]');
    if (!menu) return;

    const buttons = document.querySelectorAll(
      '[data-collection-mobile-navigation-menu-toggle]'
    );

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const isActive = menu.classList.toggle('active');
        document.body.classList.toggle('scroll-lock', isActive);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    centerActiveLink();
    initButtons();
  });

})();
